import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setCffChangeModal, setDetailsPanel } from "store/current-dashboard";
import { DetailsPanelType } from "store/current-dashboard/types";
import { language } from "language/default";
export const CffChangeModalCellRenderer = (params) => {
    const dispatch = useDispatch();
    const isGroupRow = params.node?.group;
    const handleClick = useCallback(() => {
        const leafChild = params.node?.allLeafChildren?.[0];
        const rowData = leafChild?.data ?? params.data;
        const fundName = rowData?.FundName ?? rowData?.fundName ?? "";
        dispatch(setCffChangeModal({
            fundId: rowData?.FundId ?? "",
            fundName,
            investorId: rowData?.InvestorId ?? "",
            investorInvestorId: rowData?.InvestorInvestorId ?? "",
            isGenericInvestor: rowData?.IsGenericInvestor ?? false,
            modelId: rowData?.FundCffModelId ?? "",
            // eslint-disable-next-line no-underscore-dangle
            modelName: rowData?._fundLevel_Model ?? "",
            selectedModelId: undefined
        }));
        dispatch(setDetailsPanel({
            isOpen: true,
            title: language.en.dashboard.cffChangeModal.title(fundName),
            type: DetailsPanelType.CffChangeModal
        }));
    }, [dispatch, params.data, params.node]);
    if (!isGroupRow) {
        return React.createElement("span", null);
    }
    return React.createElement(AuxButton, { icon: "edit", onClick: handleClick, type: AuxButtonTypeEnum.TERTIARY });
};
